<template>
  <div class="search-wrapper">
    <div class="search-box">
      <icon icon-class="search"></icon>
      <input type="text" class="search-input" v-model="searchKey" :placeholder="'搜索' + searchTypeText" @keyup.enter="search" />
      <div class="clear-keyword" @click.stop="clearKey"><span class="iconfont icon-close"></span></div>
    </div>
    <div class="search-main">
      <div class="history" v-if="history.length > 0 && !searched">
        <div class="title-box">
          <div class="title">历史记录</div>
          <span class="iconfont icon-delete" @click="clearHistory"></span>
        </div>
        <div class="history-list">
          <div class="history-item" v-for="item in history" @click="historySearch(item)">{{item}}</div>
        </div>
      </div>
      <div class="result-list" v-if="resultList.length > 0">
        <workshop-card v-if="searchType == 0" :item="item" v-for="item in resultList" :key="item.id"></workshop-card>
        <studio-card v-if="searchType == 1" :item="item" v-for="item in resultList" :key="item.id"></studio-card>
        <public-class-card v-if="searchType == 2" :item="item" v-for="item in resultList" :key="item.id"></public-class-card>
        <lecturer-card v-if="searchType == 3" v-for="(item, index) in resultList" :key="index" :item="item"></lecturer-card>
        <div class="load-more">
          <template v-if="noMoreData">
            <span class="no-more-text">- 没有更多了喔 -</span>
          </template>
          <template v-else>
            <span class="iconfont icon-loading loading"></span><span>正在加载更多</span>
          </template>
        </div>
      </div>
      <div class="empty-data" v-if="resultList.length == 0 && !loading && searched">
        <div><img src="/Application/Home/Resource/static/images/mobile/empty-data.png"></div>
        <span>没有相应的{{searchTypeText}}</span>
      </div>
      <div class="loading-data" v-if="loading && searched"><span class="iconfont icon-loading loading"></span>加载中</div>
    </div>
  </div>
</template>

<style lang="less" scoped>
  .search-wrapper{
    box-sizing: border-box;
    margin: 0 12px;
    .search-box{
      margin-top: 12px;
      position: relative;
      box-sizing: border-box;
      display: flex;
      justify-content: flex-start;
      align-items: center;
      width: 100%;
      height: 36px;
      padding: 0 16px 0 12px;
      box-shadow: 0 3px 14px 0 rgba(77,162,199,.08);
      border-radius: 36px;
      background: #FFF;
      z-index: 100;
      svg{
        font-size: 24px;
        color: #CACACA;
      }
      .search-input{
        font-size: 14px;
        width: calc(~"100% - 27px - 46px");
        color: #333;
      }
      .clear-keyword{
        position: absolute;
        top: 0;
        right: 0;
        display: flex;
        justify-content: center;
        align-items: center;
        height: 36px;
        width: 46px;
        .icon-close{
          font-size: 16px;
          color: #CDCDCD;
        }
      }
    }
    .search-main{
      .history{
        padding: 32px 12px 0;
        .title-box{
          display: flex;
          justify-content: space-between;
          align-items: center;
          color: #999;
          font-size: 14px;
          .iconfont{
            font-size: 12px;
            color: #CDCDCD;
          }
        }
        .history-list{
          margin-top: 12px;
          display: flex;
          flex-wrap: wrap;
          justify-content: flex-start;
          .history-item{
            padding: 0 12px;
            height: 28px;
            line-height: 28px;
            font-size: 14px;
            color: #666;
            background: #F7FAFB;
            border-radius: 28px;
            margin: 0 20px 12px 0;
            white-space: nowrap;
            max-width: 100%;
            overflow: hidden;
            text-overflow: ellipsis;
          }
        }
      }
      .result-list{
        padding-top: 12px;
      }
    }
    .load-more {
      height: 60px;
      width: 100%;
      line-height: 60px;
      text-align: center;
      font-size: 28rpx;
    }
    .load-more span {
      color: #666;
    }
    .load-more .iconfont{
      font-size: 24rpx;
    }
    .load-more .no-more-text{
      color: #999;
    }

    @keyframes loading {
      0% {transform: rotate(0deg)}
      50% {transform: rotate(180deg)}
      100% {transform: rotate(360deg)}
    }
    .loading {
      display: inline-block;
      transform-origin: 50% 50%;
      position: relative;
      left: -3px;
      top: -1px;
      animation: loading 1s linear infinite;
    }

    .empty-data{
      padding-top: 152px;
      text-align: center;
      color: #999;
    }
    .empty-data img{
      width: 64px;
    }
    .empty-data span{
      display: inline-block;
      margin-top: 16px;
      font-size: 14px;
      line-height: 14px;
      color: #999;
    }
    .loading-data{
      margin-top: 30px;
      text-align: center;
      color: #999;
      font-size: 14px;
    }
    .loading-data span{
      font-size: 12px;
    }
  }
</style>

<script>
  import WorkshopCard from '@/components/Course/Cards/workshopCard'
  import StudioCard from '@/components/Course/Cards/studioCard'
  import PublicClassCard from '@/components/Course/Cards/publicClassCard'
  import LecturerCard from '@/components/Common/lecturerCard'
  export default {
    data() {
      return {
        searchType: 1,
        searchKey: '',
        history: [],
        historyStorage: {},
        resultList: [],
        page: 1,
        noMoreData: false,
        userInfo: {},
        searched: false,
        emptyData: false,
        loading: false,
      }
    },
    computed: {
      searchTypeText() {
        switch(parseInt(this.searchType)) {
          case 0: return '小组课';
          case 1: return '设计室';
          case 2: return '公开课';
          case 3: return '讲师';
        }
      },
      searchTypeEnglish() {
        switch(parseInt(this.searchType)) {
          case 0: return 'workshop';
          case 1: return 'studio';
          case 2: return 'publicClass';
          case 3: return 'teacher';
        }
      }
    },
    components: {
      WorkshopCard,
      StudioCard,
      PublicClassCard,
      LecturerCard
    },
    created() {
      this.searchType = this.$route.query.type;
      this.historyStorage = store.get('history') || {};
      this.history = this.historyStorage && this.historyStorage[this.searchTypeEnglish] ? this.historyStorage[this.searchTypeEnglish].reverse() : [];
    },
    methods: {
      clearKey() {
        this.searchKey = '';
        this.searched = false;
        this.resultList = [];
      },
      // 搜索课程
      searchData(type, page, cb, more = false) {
        this.loading = true;
        let postUrl = '';
        let postData = {
          page: page ? page : 1,
          count: 9999,
          search: this.searchKey || '',
        }
        switch(parseInt(type)) {
          case 0: {
            // 小组课
            postUrl = '/Course/get_workshop_list';
          };break;
          case 1: {
            // 设计室
            postUrl = '/Course/get_studio_list';
          };break;
          case 2: {
            // 公开课
            postUrl = '/Course/get_openlecture_list';
          };break;
          case 3: {
            // 讲师
            postUrl = '/Lecturer/get_lecturer_list';
            postData.location = '';
            postData.major = '';
            postData.level = '';
            postData.service = '';
          };break;
        };
        this.$root.post(postUrl, postData).then(data => {
          this.loading = false;
          // 设置已无加载内容状态
          this.noMoreData = data.is_over == 0 ? true : false;
          // 加载数据
          if(more) {
            // 加载更多 合并现有数据
            this.resultList = [...this.resultList, ...data.info];
          }else {
            if(data.info.length == 0) {
              this.emptyData = true;
            }
            // 重置数据为第一页
            this.resultList = data.info || [],
            this.page = 1;
            this.noMoreData = data.is_over == 0 ? true : false;
          }
          // 回调
          cb && cb();
        })
      },
      // 删除历史记录
      clearHistory() {
        this.history = [];
        this.historyStorage[this.searchTypeEnglish] = [];
        store.set('history', this.historyStorage);
      },
      // 保存历史记录
      saveHistory() {
        this.searched = true;
        let list = this.history.reverse();
        if(list.indexOf(this.searchKey) == -1 && this.searchKey != '') {
          list.push(this.searchKey);
          let reverseList = JSON.parse(JSON.stringify(list)).reverse();
          this.history = reverseList;
          // this.$set(this.historyStorage, this.searchTypeEnglish, list);
          this.historyStorage[this.searchTypeEnglish] = list;
          store.set('history', this.historyStorage);
        }
      },
      // 点击历史记录直接搜索
      historySearch(value) {
        this.searchKey = value;
        this.search();
      },
      // 搜索
      search() {
        this.searchData(this.searchType, 1, this.saveHistory());
      },
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Course/search.vue